import { AxiosResponse, axios } from '~/modules'
import { ISystemWarnings } from '~/interfaces'

const { REACT_APP_API_HSTORY_URL: hstoryAPI } = process.env

export const fetchSystemWarnings = async (): Promise<ISystemWarnings[]> => {
  const response = await axios.get(`${hstoryAPI}/system-warnings`)
  const { data }: AxiosResponse<ISystemWarnings[]> = response
  return data
}
